import {IPropertyWrapper} from "./DocumentationTypes";

/**
 * Sort the properties first by required then alphabetically
 */
export function sortProperties(properties: IPropertyWrapper[]): void {
  const sortAlphabetically = (a: IPropertyWrapper, b: IPropertyWrapper) => {
    const aName = a.name.toLowerCase();
    const bName = b.name.toLowerCase();
    if (aName < bName) {
      return -1;
    }
    if (aName > bName) {
      return 1;
    }
    return 0;
  };

  // Get all the required properties
  const requiredProps = properties.filter(prop => prop.isRequired);
  const optionalProps = properties.filter(prop => !prop.isRequired);

  // Sort each group alphabetically
  requiredProps.sort(sortAlphabetically);
  optionalProps.sort(sortAlphabetically);

  // Combine the two lists
  properties.length = 0; // Clear the original array
  properties.push(...requiredProps, ...optionalProps);
}